
const lang = getQueryStringFn("lang");
let defLang = lang || 'zh-CN';
if (defLang !== 'zh-CN') {
    defLang = 'EN'
}
let interdeal = {
    "sitekey": "3127b292be2623ffc25300868347f917",
    "Position": "left",
    "domains": {
       "js": "https://cdn.equalweb.com/",
        "acc": "https://access.equalweb.com/"
    },
    "Menulang": defLang,
    "btnStyle": {
        "vPosition": [
            "80%",
            "20%"
        ],
        "scale": [
            "0.5",
            "0.5"
        ],
        "color": {
            "main": "#d74123",
            "second": "#ffffff"
        },
        "icon": {
            "outline": false,
            "type": 11,
            "shape": "circle"
        }
    }
};


module.exports = { interdeal }

//获取浏览器参数
function getQueryStringFn(name) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const r = window.location.search.substring(1).match(reg);
    if (r != null) {
        return decodeURI(r[2]);
    } return null;
}